import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api, formatApiError } from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { Check, X } from "lucide-react";

export default function DeletionApprovalsPage() {
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [err, setErr] = useState("");

  const load = async () => {
    const params = filter ? { status: filter } : {};
    const { data } = await api.get("/deletion-requests", { params });
    setRequests(data);
  };
  useEffect(() => { load(); }, [filter]);

  const review = async (id, decision) => {
    const note = window.prompt(`Optional note for ${decision}:`, "") || "";
    setErr("");
    try {
      await api.post(`/deletion-requests/${id}/review`, { decision, note });
      load();
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail));
    }
  };

  return (
    <AppShell
      title="Deletion Approvals"
      actions={
        <select className="ds-input w-44" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="deletion-filter">
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
        </select>
      }
    >
      {err && <div className="text-[12px] text-[#B42318] mb-3">{err}</div>}
      <div className="ds-card overflow-x-auto">
        <table className="ds-table" data-testid="deletion-table">
          <thead>
            <tr>
              <th>Document</th>
              <th>Requested by</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Reviewer</th>
              <th>Created</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => (
              <tr key={r.id} data-testid={`deletion-row-${r.id}`}>
                <td className="font-mono text-[11px]">{r.document_id.slice(0, 8)}</td>
                <td>{r.requested_by_name}</td>
                <td className="text-[12px]">{r.reason}</td>
                <td>
                  <StatusBadge variant={r.status === "approved" ? "success" : r.status === "rejected" ? "error" : "warning"}>
                    {r.status}
                  </StatusBadge>
                </td>
                <td>{r.reviewed_by_name || "—"}</td>
                <td className="font-mono text-[11px]">{new Date(r.created_at).toLocaleString()}</td>
                <td className="text-right">
                  {r.status === "pending" && (
                    <div className="flex justify-end gap-2">
                      <button className="ds-btn-secondary flex items-center gap-1" onClick={() => review(r.id, "reject")} data-testid={`reject-${r.id}`}>
                        <X size={13} /> Reject
                      </button>
                      <button className="ds-btn-primary flex items-center gap-1" onClick={() => review(r.id, "approve")} data-testid={`approve-${r.id}`}>
                        <Check size={13} /> Approve
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            {requests.length === 0 && (
              <tr><td colSpan={7} className="text-center text-[#8A8A93] py-8">Nothing here.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
